import { render, staticRenderFns } from "./BranchHistory.vue?vue&type=template&id=ed0995f2&scoped=true&"
import script from "./BranchHistory.vue?vue&type=script&lang=ts&"
export * from "./BranchHistory.vue?vue&type=script&lang=ts&"
import style0 from "./BranchHistory.vue?vue&type=style&index=0&id=ed0995f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0995f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VRow})
